import styled from 'styled-components';
import { media } from '@prima-afp/prima-ui-elements/dist/utils/media/styledConfig';

export const Wrapper = styled.div`
  height: 100vh;
  display: grid;
  grid-template-columns: ${({ heroShow = true }) => heroShow ? '1fr 2fr' : '0 2fr'}; // for template areas
  grid-template-rows: auto;
  grid-template-areas:
    "hero content";

  overflow: auto;
  overflow-x: hidden;

  ${media.sm`
    grid-template-areas:
      "hero"
      "content";
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  `}
  ${media.xs`
    grid-template-areas:
      "hero"
      "content";
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  `}
`;

export const ContentGrid = styled.div`
  grid-area: content;
  background-color: white;
`;

